import { createFileRoute, redirect } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { tokenStore } from '@/auth/token';
import { APP_ROUTES } from '@/const/routes';

const SignupPage = lazy(() =>
  import('@/features/auth/signup/SignupPage').then((m) => ({ default: m.SignupPage })),
);

export const Route = createFileRoute('/sign-up')({
  beforeLoad: () => {
    if (tokenStore.get()) {
      throw redirect({ to: APP_ROUTES.app.index });
    }
  },
  component: () => (
    <Suspense>
      <SignupPage />
    </Suspense>
  ),
});
